interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-file-list-3-line',
    title: '下拉式阅读',
    desc: '无需翻页点击，像刷社交动态一样流畅阅读漫画。滚动到底自动加载下一话，追番体验丝滑顺畅。',
  },
  {
    icon: 'ri-time-line',
    title: '每日同步更新',
    desc: '与日本、韩国、国内各大平台同步更新，新番上线第一时间同步，完结番剧全集一次放出。',
  },
  {
    icon: 'ri-global-line',
    title: '日韩国漫全覆盖',
    desc: '日漫、韩漫、国漫三大品类，热血、恋爱、奇幻、悬疑、搞笑等全题材覆盖，20000+资源任意看。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台适配',
    desc: '手机、平板、电脑全终端适配，打开浏览器即可畅享高清阅读体验，收藏进度多端同步。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '正版安全无广告',
    desc: '51动漫坚持正版内容路线，阅读过程清爽干净，无弹窗骚扰，保护你的阅读体验与设备安全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            为什么数百万动漫迷选择51动漫？五大核心优势告诉你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6 text-center group cursor-pointer hover:bg-background-200/30 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}